<template>
    <!--Waiting List Enroll Info First Screen-->
    <div class="enroll-info-screen">
        <div class="enroll-wrapper">
            <p>{{ $ml.get("waitingListEnroll.firstScreenP") }}</p>
            <p>{{ $ml.get("waitingListEnroll.firstScreenP2") }}</p>
            <div class="list-wrapper">
                <p v-html="$ml.get('waitingListEnroll.firstScreenP3')"></p>
                <ul>
                    <li v-html="$ml.get('waitingListEnroll.firstScreenP3Li1')"></li>
                    <li v-html="$ml.get('waitingListEnroll.firstScreenP3Li2')"></li>
                </ul>
            </div>
            <p v-html="$ml.get('waitingListEnroll.firstScreenP4')"></p>
            <p v-html="$ml.get('waitingListEnroll.firstScreenP5')"></p>
            <p>{{ $ml.get("waitingListEnroll.firstScreenP6") }}</p>
            <div class="trial-expired-wrap" v-if="adminDetails.web_trial_expired">
                <p class="trial-expired">
                    {{ $ml.get("waitingListEnroll.firstScreenP7") }} Go to <router-link class="main-text-link"
                        :to="{ path: '/app/subscription-payments' }">
                        Subscription & Payments.
                    </router-link>
                </p>

            </div>
        </div>
        <!--Waiting List Enroll Read More Button-->
        <div class="enroll-btn">
            <button @click="changeScreen('secound-screen')" class="primary-btn extra-small mobile"
                :class="{ 'disabled-button': adminDetails.web_trial_expired }">
                {{ $ml.get("general.continue") }}
            </button>
        </div>
    </div>
</template>

<script>
import store from "../../../../services/vuex";

export default {
    data() {
        return {};
    },
    computed: {
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        this.checkEnrollmentIsComplete()
    },
    methods: {
        changeScreen(screen) {
            this.$emit('change-screen', screen);
        },
        checkEnrollmentIsComplete() {
            if (this.adminDetails) {
                if (this.adminDetails.waiting_list_subscription_active && !this.adminDetails.waiting_list_enrollment_finished) {
                    // Condition: Active and not finished
                    this.changeScreen('enroll-step-three');
                } else if (!this.adminDetails.waiting_list_subscription_active && !this.adminDetails.waiting_list_enrollment_finished) {
                    // Condition: Not active and not finished
                    this.changeScreen('first-screen');
                }
            }
        }

    },
    components: {}
};
</script>
